module.exports = __webpack_public_path__ + "r-v3/img/trash_white.7cfb4f10.svg";